import { render, staticRenderFns } from "./AdditionalBillingComponent.vue?vue&type=template&id=5cd5e2b8&"
import script from "./AdditionalBillingComponent.vue?vue&type=script&lang=js&"
export * from "./AdditionalBillingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports